import { j as t } from "./jsx-runtime-3tyXYecC.mjs";
import * as R from "react";
import { forwardRef as E } from "react";
import { f as g } from "./index-LyFokDcn.mjs";
import { F as b } from "./flex-Cc3osQLf.mjs";
import { L as S } from "./layout-box-DFBM-kSI.mjs";
import { F as H, f as B, u as D } from "./use-input-icon-Dk75O5Ch.mjs";
import { c as O, m as j } from "./tss-DN0acMKN.mjs";
import { B as $ } from "./Box-B5hjovXR.mjs";
import { M as I, d as C } from "./constants-CnFYFetN.mjs";
import { F } from "./form-note-CbSVsgBQ.mjs";
import { S as q } from "./status-message-BMoS1d1Y.mjs";
import { F as A } from "./FormControl-C7vROVtA.mjs";
import { g as T, c as U } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { f as P } from "./formControlState-vgaj2ksH.mjs";
import { u as G } from "./useFormControl-C9UMlaFq.mjs";
import { s as V, b as J, u as K, c as Q } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { m as X } from "./memoTheme-BzXKG_-k.mjs";
import { g as Y } from "./generateUtilityClasses-CWIIr9E_.mjs";
function Z(n) {
  return T("MuiInputLabel", n);
}
Y("MuiInputLabel", ["root", "focused", "disabled", "error", "required", "asterisk", "formControl", "sizeSmall", "shrink", "animated", "standard", "filled", "outlined"]);
const _ = (n) => {
  const {
    classes: r,
    formControl: o,
    size: e,
    shrink: i,
    disableAnimation: l,
    variant: d,
    required: c
  } = n, x = {
    root: ["root", o && "formControl", !l && "animated", i && "shrink", e && e !== "normal" && `size${O(e)}`, d],
    asterisk: [c && "asterisk"]
  }, m = Q(x, Z, r);
  return {
    ...r,
    // forward the focused, disabled, etc. classes to the FormLabel
    ...m
  };
}, rr = V(H, {
  shouldForwardProp: (n) => J(n) || n === "classes",
  name: "MuiInputLabel",
  slot: "Root",
  overridesResolver: (n, r) => {
    const {
      ownerState: o
    } = n;
    return [{
      [`& .${B.asterisk}`]: r.asterisk
    }, r.root, o.formControl && r.formControl, o.size === "small" && r.sizeSmall, o.shrink && r.shrink, !o.disableAnimation && r.animated, o.focused && r.focused, r[o.variant]];
  }
})(X(({
  theme: n
}) => ({
  display: "block",
  transformOrigin: "top left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%",
  variants: [{
    props: ({
      ownerState: r
    }) => r.formControl,
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: "translate(0, 20px) scale(1)"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      // Compensation for the `Input.inputSizeSmall` style.
      transform: "translate(0, 17px) scale(1)"
    }
  }, {
    props: ({
      ownerState: r
    }) => r.shrink,
    style: {
      transform: "translate(0, -1.5px) scale(0.75)",
      transformOrigin: "top left",
      maxWidth: "133%"
    }
  }, {
    props: ({
      ownerState: r
    }) => !r.disableAnimation,
    style: {
      transition: n.transitions.create(["color", "transform", "max-width"], {
        duration: n.transitions.duration.shorter,
        easing: n.transitions.easing.easeOut
      })
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(12px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "filled",
      size: "small"
    },
    style: {
      transform: "translate(12px, 13px) scale(1)"
    }
  }, {
    props: ({
      variant: r,
      ownerState: o
    }) => r === "filled" && o.shrink,
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      transform: "translate(12px, 7px) scale(0.75)",
      maxWidth: "calc(133% - 24px)"
    }
  }, {
    props: ({
      variant: r,
      ownerState: o,
      size: e
    }) => r === "filled" && o.shrink && e === "small",
    style: {
      transform: "translate(12px, 4px) scale(0.75)"
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(14px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "outlined",
      size: "small"
    },
    style: {
      transform: "translate(14px, 9px) scale(1)"
    }
  }, {
    props: ({
      variant: r,
      ownerState: o
    }) => r === "outlined" && o.shrink,
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      // Theoretically, we should have (8+5)*2/0.75 = 34px
      // but it feels a better when it bleeds a bit on the left, so 32px.
      maxWidth: "calc(133% - 32px)",
      transform: "translate(14px, -9px) scale(0.75)"
    }
  }]
}))), z = /* @__PURE__ */ R.forwardRef(function(r, o) {
  const e = K({
    name: "MuiInputLabel",
    props: r
  }), {
    disableAnimation: i = !1,
    margin: l,
    shrink: d,
    variant: c,
    className: x,
    ...m
  } = e, f = G();
  let s = d;
  typeof s > "u" && f && (s = f.filled || f.focused || f.adornedStart);
  const a = P({
    props: e,
    muiFormControl: f,
    states: ["size", "variant", "required", "focused"]
  }), u = {
    ...e,
    disableAnimation: i,
    formControl: f,
    shrink: s,
    size: a.size,
    variant: a.variant,
    required: a.required,
    focused: a.focused
  }, h = _(u);
  return /* @__PURE__ */ t.jsx(rr, {
    "data-shrink": s,
    ref: o,
    className: U(h.root, x),
    ...m,
    ownerState: u,
    classes: h
  });
}), er = j()(({ spacing: n }, { inputHasLabel: r, notePlacement: o }) => g.ifFeature(
  "encore",
  {
    root: {
      alignItems: o === "block" ? "start" : "center",
      display: "flex",
      flexDirection: o === "block" ? "column" : "row",
      gap: n(1),
      width: "100%"
    }
  },
  {
    root: {
      marginTop: r ? n(2.5) : void 0
    }
  }
)), or = ({ children: n, inputHasLabel: r, notePlacement: o }) => {
  const { classes: e } = er({ inputHasLabel: r, notePlacement: o });
  return /* @__PURE__ */ t.jsx($, { alignItems: "center", className: e.root, display: "flex", children: n });
}, nr = j()((n, r) => {
  var a, u, h, w, y;
  const { mixins: o, palette: e, spacing: i, typography: l, mode: d } = n, { disabled: c, labelPlacement: x, status: m, viewMode: f } = r;
  let s = e.gray[900];
  return c ? s = e.gray[600] : m ? s = o.fieldStatusColor(m, e) : f && (s = e.gray[700]), g.ifFeature(
    "encore",
    {
      root: {
        alignItems: "start",
        columnGap: i(1.5),
        display: "inline-flex",
        flexDirection: x === "inline" ? "row" : "column",
        outline: d === I.Dye ? `1px solid ${C.main}` : void 0,
        rowGap: i(0.5)
      },
      /**
       * We should avoid using `display: flex` on the label because it will push the required asterisk to the side
       * if the label spans more than one line. See: https://bamboohr.atlassian.net/browse/EN-3781
       */
      label: {
        alignItems: "center",
        color: s,
        fontSize: (a = l.small) == null ? void 0 : a.fontSize,
        fontWeight: l.fontWeightMedium,
        lineHeight: (u = l.small) == null ? void 0 : u.lineHeight,
        position: "relative",
        transform: "none",
        whiteSpace: "wrap",
        zIndex: "unset",
        "&.MuiInputLabel-root": {
          maxWidth: "unset"
        },
        "& > .MuiInputLabel-asterisk": {
          marginLeft: "-3px",
          // This removes the space between the label and the asterisk
          color: s,
          fontSize: (h = l.small) == null ? void 0 : h.fontSize,
          fontWeight: l.fontWeightMedium,
          lineHeight: (w = l.small) == null ? void 0 : w.lineHeight
        },
        "&.Mui-disabled": {
          color: s
        },
        "&.Mui-focused": {
          color: s
        },
        pointerEvents: "auto"
      },
      /**
       * The label wrapper is being set to a fixed height via `classes.label` so that the label will remain centered with
       * the top row of the input when the input is multi-line. See: https://bamboohr.atlassian.net/browse/FAB-3303
       */
      labelWrapper: {
        alignItems: "center",
        display: "flex",
        flexShrink: 0,
        gap: i(0.5)
      },
      error: {
        color: e.error.main,
        fill: e.error.main
      },
      warning: {
        color: e.warning.main,
        fill: e.warning.main
      },
      info: {
        color: e.info.main,
        fill: e.info.main
      },
      note: {}
    },
    {
      root: {
        outline: d === I.Dye ? `1px solid ${C.main}` : void 0
      },
      label: {
        display: "flex",
        alignItems: "center",
        fontSize: (y = l.small) == null ? void 0 : y.fontSize,
        whiteSpace: "nowrap",
        lineHeight: 1,
        "&>svg": {
          marginRight: i(0.75)
        },
        "& > .MuiInputLabel-asterisk": {
          color: e.primary.main
        },
        "&.Mui-focused": {
          color: m ? e[m].main : e.grey[800]
        },
        pointerEvents: "auto"
      },
      labelWrapper: {},
      error: {
        color: e.error.main,
        fill: e.error.main
      },
      warning: {
        color: e.warning.main,
        fill: e.warning.main
      },
      info: {
        color: e.info.main,
        fill: e.info.main
      },
      note: {}
      // needed for props checking
    }
  );
}), Sr = E(
  ({
    afterLabel: n,
    children: r,
    classes: o = {},
    className: e,
    disabled: i = !1,
    id: l,
    InputLabelProps: d,
    label: c,
    labelPlacement: x,
    note: m,
    notePlacement: f,
    required: s = !1,
    status: a,
    statusMessage: u,
    statusMessageId: h,
    variant: w,
    viewMode: y,
    width: W,
    ...L
  }, M) => {
    const { classes: p, cx: v } = nr({ disabled: i, labelPlacement: x, status: a, viewMode: y }), k = D(a), N = [L["data-fabric-component"], "InputWrapper"].filter(Boolean).join(" ");
    return /* @__PURE__ */ t.jsxs(
      A,
      {
        className: v(e, o.root, p.root),
        "data-fabric-component": N,
        error: a === "error",
        fullWidth: W === 100,
        ref: M,
        children: [
          c && g.ifFeature(
            "encore",
            /* @__PURE__ */ t.jsx("div", { className: v(o.label, p.labelWrapper), children: typeof c == "string" ? /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
              k && !i && /* @__PURE__ */ t.jsx(b, { marginRight: 0.5, children: k }),
              /* @__PURE__ */ t.jsx(
                z,
                {
                  ...d,
                  classes: { root: p.label },
                  className: v({
                    [p.error]: a === "error",
                    [p.warning]: a === "warning",
                    [p.info]: a === "info"
                  }),
                  disabled: i,
                  error: a === "error",
                  htmlFor: l,
                  required: s,
                  shrink: !1,
                  children: c
                }
              ),
              n
            ] }) : c }),
            /* @__PURE__ */ t.jsx(b, { alignItems: "center", flexShrink: 0, gap: 0.5, children: /* @__PURE__ */ t.jsxs(
              z,
              {
                ...d,
                classes: { root: p.label },
                className: v(
                  {
                    [p.error]: a === "error",
                    [p.warning]: a === "warning",
                    [p.info]: a === "info"
                  },
                  o.label
                ),
                disabled: i,
                error: a === "error",
                htmlFor: l,
                required: s,
                shrink: !0,
                children: [
                  !i && k,
                  c,
                  n ? /* @__PURE__ */ t.jsx(S, { marginLeft: 0.5, children: n }) : void 0
                ]
              }
            ) })
          ),
          /* @__PURE__ */ t.jsxs(or, { inputHasLabel: !!c, notePlacement: f, children: [
            r,
            w === "single" || !m ? null : g.ifFeature(
              "encore",
              /* @__PURE__ */ t.jsx(F, { classes: { root: p.note }, disabled: i, status: a, children: m }),
              /* @__PURE__ */ t.jsx(
                S,
                {
                  marginLeft: g.ifFeature("encore", void 0, 1),
                  marginTop: g.ifFeature("encore", void 0, "2px"),
                  children: /* @__PURE__ */ t.jsx(F, { classes: { root: p.note }, disabled: i, status: a, children: m })
                }
              )
            )
          ] }),
          (a === "error" || a === "warning") && u && /* @__PURE__ */ t.jsx(S, { marginTop: 0.5, children: /* @__PURE__ */ t.jsx(q, { id: h, message: u, status: a }) })
        ]
      }
    );
  }
);
export {
  Sr as I,
  or as N,
  z as a
};
//# sourceMappingURL=input-wrapper-qaVcukod.mjs.map
